<template>
  <card :card-title="$t('homepage.txt006')" title-image="trend" v-loading="loading">
    <template #ope>
      <el-date-picker
        class="operation-item"
        v-model="year"
        type="year"
        :placeholder="$t('homepage.txt007')"
        :clearable="false"
        @change="getData"
        value-format="yyyy"
      >
      </el-date-picker>
    </template>
    <div class="chart" id="trendChart"></div>
  </card>
</template>

<script>
  import Card from './Card';
  import { validatenull } from "@/util/validate";
  import { getCloudStatisticByMonthInBM, getCloudStatisticByMonthInGR } from "@/api/home/home";
  import {mapGetters} from "vuex";

  export default {
    name: "TrendAnalysis",
    components: {
      Card
    },
    data() {
      return {
        loading: false,
        year: new Date().getFullYear().toString(),
        chart: null,
        chartData: []
      }
    },
    methods: {
      initChart() {
        const chartDom = document.getElementById('trendChart');
        this.chart = this.$echarts.init(chartDom);
        this.getData()
      },
      getData(){
        this.loading = true
        let param = {
          type:'ajax',
          year: this.year
        }
        if (!validatenull(this.userInfo.optOrgScale)){
          param.deptId = this.userInfo.optOrgScale.map(item => item.id).join(",");
          getCloudStatisticByMonthInBM(param)
            .then(res => {
              this.loading = false
              this.setOptions(res.data.data)
            })
            .catch(() => {
              this.loading = false
            })
        }else{
          getCloudStatisticByMonthInGR(param)
            .then(res => {
              this.loading = false
              this.setOptions(res.data.data)
            })
            .catch(() => {
              this.loading = false
            })
        }

      },
      setOptions(chartData) {
        const option = {
          title: {
            text: this.$t('homepage.txt011'), //报销费用月度统计，单位（元）
            left: 'center'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [chartData.year + '', chartData.lastYear + ''],
            left: 'right',
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', "12",]
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: chartData.year + '',
              type: 'line',
              data: chartData.newData,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: function (params) {
                      return params.value.toLocaleString();
                    }
                  }
                }
              }
            },
            {
              name: chartData.lastYear + '',
              type: 'line',
              data: chartData.oldData,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: function (params) {
                      return params.value.toLocaleString();
                    }
                  }
                }
              }
            }
          ]
        };
        this.chart.setOption(option)
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    computed: {
      ...mapGetters(['userInfo'])
    }
  }
</script>

<style scoped>
  .chart {
    height: 100%;
  }
</style>
